import React from 'react';
import HomeIcon from '@images/owner/home.svg';
import HomeSelectIcon from '@images/owner/homeSelect.svg';
import WalletIcon from '@images/owner/wallet.svg';
import WalletSelectIcon from '@images/owner/walletSelect.svg';
import AssignmentIcon from '@images/owner/assignment.svg';
import AssignmentSelectIcon from '@images/owner/assignmentSelect.svg';
import PersonalBagIcon from '@images/owner/personal_bag_select.svg';
import PersonalBagSelectIcon from '@images/owner/personal_bag.svg';
import GearIcon from '@images/owner/gear.svg';
import GearIconSelect from '@images/owner/gearSelect.svg';
import ShareIcon from '@images/owner/share-square-line.svg';
import ShareSelectIcon from '@images/owner/share-square-line-select.svg';
import TrophyIcon from '@images/owner/trophy.svg';
import TrophySelectIcon from '@images/owner/trophy.svg';
import MapLocationDotIcon from '@images/owner/map-location-dot.svg';
import MapLocationDotSelectedIcon from '@images/owner/map-location-dot-selected.svg';
import { OpenNewTabIcon, OpenNewTabSelectIcon } from '@util/svgicon';
import { featureFlags } from '@constants/config';
import { ROUTES } from '@constants/routes';
import { APP_MODES } from '@redux/slices/appModeSlice';

// For staking icon, we'll use a simple inline SVG since we don't have specific icons
const StakingIcon = () => (
	<svg
		width="24"
		height="24"
		viewBox="0 0 24 24"
		fill="none"
		stroke="#727272"
		strokeWidth="2"
		strokeLinecap="round"
		strokeLinejoin="round"
	>
		<path d="M12 2L2 7l10 5 10-5-10-5z" />
		<path d="m2 17 10 5 10-5" />
		<path d="m2 12 10 5 10-5" />
	</svg>
);

const StakingIconSelected = () => (
	<svg
		width="24"
		height="24"
		viewBox="0 0 24 24"
		fill="none"
		stroke="#000000"
		strokeWidth="2"
		strokeLinecap="round"
		strokeLinejoin="round"
	>
		<path d="M12 2L2 7l10 5 10-5-10-5z" />
		<path d="m2 17 10 5 10-5" />
		<path d="m2 12 10 5 10-5" />
	</svg>
);

// Video upload icon for RoboCaps
const VideoUploadIcon = () => (
	<svg
		width="24"
		height="24"
		viewBox="0 0 24 24"
		fill="none"
		stroke="#727272"
		strokeWidth="2"
		strokeLinecap="round"
		strokeLinejoin="round"
	>
		<path d="m22 8-6 4 6 4V8Z" />
		<rect
			width="14"
			height="12"
			x="2"
			y="6"
			rx="2"
			ry="2"
		/>
	</svg>
);

const VideoUploadIconSelected = () => (
	<svg
		width="24"
		height="24"
		viewBox="0 0 24 24"
		fill="none"
		stroke="#000000"
		strokeWidth="2"
		strokeLinecap="round"
		strokeLinejoin="round"
	>
		<path d="m22 8-6 4 6 4V8Z" />
		<rect
			width="14"
			height="12"
			x="2"
			y="6"
			rx="2"
			ry="2"
		/>
	</svg>
);

// Earth Rovers menu items
const earthRoversItems = [
	{
		name: 'Home',
		icon: HomeIcon,
		selectIcon: HomeSelectIcon,
		path: '/owner/dashboard/'
	},
	// {
	// 	name: 'Documentation',
	// 	icon: AssignmentIcon,
	// 	selectIcon: AssignmentSelectIcon,
	// 	path: '/owner/documentation',
	// 	tab: <OpenNewTabIcon />,
	// 	selectTab: <OpenNewTabSelectIcon />
	// },
	{
		name: 'Inventory',
		icon: PersonalBagIcon,
		selectIcon: PersonalBagSelectIcon,
		path: '/owner/inventory/'
	},
	{
		name: 'Wallet',
		icon: WalletIcon,
		selectIcon: WalletSelectIcon,
		tab: <OpenNewTabIcon />,
		selectTab: <OpenNewTabSelectIcon />,
		link: 'https://wallet.web3auth.io/v4/'
	},
	{
		name: 'Advanced Sharing',
		icon: ShareIcon,
		selectIcon: ShareSelectIcon,
		path: '/owner/advancedsharing/'
	},
	...(featureFlags.SHARE_API_KEYS
		? [
			{
				name: 'Settings',
				icon: GearIcon,
				selectIcon: GearIconSelect,
				path: '/owner/settings/'
			}
		]
		: []),
	{
		name: 'AI Agents',
		icon: PersonalBagIcon,
		selectIcon: PersonalBagSelectIcon,
		path: '/owner/ai-agents/'
	},
	{
		name: 'Tournaments',
		icon: TrophyIcon,
		selectIcon: TrophySelectIcon,
		path: `/${ROUTES.ownerTournaments}`
	},
	{
		name: 'Geofences',
		icon: MapLocationDotIcon,
		selectIcon: MapLocationDotSelectedIcon,
		path: `/${ROUTES.ownerGeofences}`
	},
	{
		name: 'Staking',
		icon: StakingIcon,
		selectIcon: StakingIconSelected,
		path: '/owner/staking/'
	}
];

// RoboCaps menu items
const robocapsItems = [
	{
		name: 'Home',
		icon: HomeIcon,
		selectIcon: HomeSelectIcon,
		path: '/owner/dashboard/'
	},
	{
		name: 'Video Uploads',
		icon: VideoUploadIcon,
		selectIcon: VideoUploadIconSelected,
		path: '/owner/video-uploads/'
	}
];

// Function to get sidenav items based on app mode
export const getSidenavItems = (mode) => {
	if (mode === APP_MODES.ROBOCAPS) {
		return robocapsItems;
	}
	return earthRoversItems;
};

// Default export for backwards compatibility
export default earthRoversItems;
